<template>
  <div class="d-flex flex-column pa-6 neutral-99 rounded-card align-center">
    <span class="body-label-caption neutral-40-light--text text-center mb-1"
      >{{ title }}
      <v-tooltip v-if="tooltip" max-width="200px" top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-on="on"
            v-bind="attrs"
            size="12"
            class="ml-1 neutral-70--text"
            style="margin-bottom: 2px"
          >
            mdi-information
          </v-icon>
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
    </span>
    <span class="body-regular-smaller neutral-40-light--text text-center mb-1">
      {{ description }}
    </span>
    <RetentionCardBtnSkeleton v-if="loading" />
    <base-btn
      type="tertiary"
      size="small"
      v-else
      @click="openActionModal"
      :disabled="disabled"
    >
      <v-icon size="20" class="mr-2">mdi-plus</v-icon>
      <span class="body-bold-small">
        {{ $i18next.t('message.pages.analyticsV3.retentionv3.add') }}
      </span>
    </base-btn>
  </div>
</template>

<script>
import RetentionCardBtnSkeleton from '../SkeletonLoaders/RetentionCardBtn.vue'
export default {
  name: 'RetentionCard',
  components: {
    RetentionCardBtnSkeleton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    openActionModal() {
      this.$emit('openModal')
    },
  },
}
</script>

<style lang="scss" scoped>
.rounded-card {
  border-radius: 8px;
  height: 100%;
}
</style>
